<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10" style="margin-top: 10px;">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Court Name" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ (formData.resechdul_status) ?   formData.status + ' | Resechedule' : formData.status  }}  </span>
                </h3>                     
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_DETAIL }"><a @click="onClickTabDetail()" href="#tab_2" data-toggle="tab" aria-expanded="true">Schedule</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputFirstName" class="col-sm-4 control-label">First Name</label>
                              <div class="col-md-8">
                                <input :disabled="viewMode == MODE_VIEW" type="text" id="inputFirstName" v-model="formData.first_name">
                              </div>                     
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLastName" class="col-sm-4 control-label">Last Name</label>
                              <div class="col-md-8">
                                <input :disabled="viewMode == MODE_VIEW" type="text" id="inputLastName" v-model="formData.last_name">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProjectName" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <select v-model="formData.project_id" class="form-control" :disabled="viewMode == MODE_VIEW">
                                  <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputReserveDate" class="col-sm-4 control-label">Reserve Date</label>
                              <div class="col-md-8">
                                <div class="input-group">
                                  <datepicker style="width:100%" v-if="showValidFrom" :readonly="true" name="valid_from" :value=formData.reserve_date 
                                              :format=DATE_FORMAT :input-attr="{ 'id': 'reserve_date', 'disabled': viewMode == MODE_VIEW }"
                                              :input-style="{ 'width': '100%' }"></datepicker>
                                  <span class="input-group-addon">
                                    <i class="icon ion-calendar"></i>
                                  </span>
                                </div>
                              </div>                     
                            </div>                      
                          </div>
                        </div>  
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPhone" class="col-sm-4 control-label">Phone</label>
                              <div class="col-md-8">
                                <input :disabled="viewMode == MODE_VIEW" type="text" id="inputPhone" v-model="formData.phone">
                              </div>                     
                            </div> 
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputMembershipName" class="col-sm-4 control-label">Membership</label>
                              <div class="col-md-8">
                                <input :disabled="viewMode == MODE_VIEW" type="text" id="inputMembershipName" v-model="formData.membership_name">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputStatus" class="col-sm-4 control-label">Status</label>
                              <div class="col-md-8">
                                <select v-model="formData.status" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listStatus" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>                     
                            </div>
                          </div>
                        </div>                                             
                      </div>
                    </div>                   
                    <div v-bind:class="{ active: tabActive == TAB_DETAIL }" class="tab-pane" id="tab_2">
                      <div class="box no-border"> 
                        <div class="box-header">
                          <button class="btn btn-success pull-right" @click="onCreateReschedule(formData.reserve_date)"  v-if="['Draft', 'Confirmed'].includes(formData.status) && !formData.resechdul_status">
                            <span v-if="loadingReschedule"><i class="icon ion-spinner fa-spin"></i> Create Reschedule...</span>
                            <span v-else>Create Reschedule</span>
                          </button>
                        </div>                                              
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <!-- <th style="text-align:right;">Seq. No.</th> -->
                                <th style="text-align:left;">Court</th>
                                <th style="text-align:center;">Time</th>
                                <th style="text-align:right;">Quantity</th>
                                <th style="text-align:center;">Used</th>
                                <th style="text-align:center;">Using Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listDetail" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceDetail + i + 1}}</td>
                                <!-- <td style="text-align:right;" nowrap>{{ row.seq_no }}</td> -->
                                <td style="text-align:left;">{{ row.court_name }}</td>
                                <td style="text-align:center;">{{ row.schedule_time }}</td>                                
                                <td style="text-align:right;">{{ row.quantity }}</td>
                                <td style="text-align:center;"><input type="checkbox" :checked= row.is_used></td>
                                <td style="text-align:center;">{{ row.using_date }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.reservation_id }}</td>
                                <td hidden>{{ row.court_id }}</td>
                                <td hidden>{{ row.court_schedule_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>                      
                      </div>
                      <hr class="line">
                      <div class="box no-border" v-if="showReschedule"> 
                        <div class="box-header">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group" v-if="showRescheduleDate">
                                <label for="inputReserveDate" class="col-sm-5 control-label">Reschedule Reserve Date</label>
                                <div class="col-md-7">
                                  <div class="input-group" >
                                    <datepicker style="width:100%" :readonly="true" name="valid_from" :value=date_reschedule 
                                              :format=DATE_FORMAT :input-attr="{ 'id': 'reschedule_reserve_date', }"
                                              :input-style="{ 'width': '100%' }" @change="onChangeRescheduleDate"></datepicker>
                                  <span class="input-group-addon">
                                    <i class="icon ion-calendar"></i>
                                  </span>
                                  </div>
                                </div>                     
                              </div>                      
                            </div>
                            <div class="col-md-6">
                              <button class="btn btn-info pull-right" @click="onSubmitReschedule()">
                                <span v-if="loadingSaveReschedule"><i class="icon ion-spinner fa-spin"></i> Save Reschedule...</span>
                                <span v-else>Save Reschedule</span>
                              </button>
                            </div>
                          </div>
                        </div>                                              
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:left;">Court</th>
                                <th style="text-align:center;">Time</th>
                                <th style="text-align:right;">Quantity</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listReschdule" v-bind:key="i">
                                <td style="text-align:center;"><input type="checkbox" :value= row.id v-model="selectedReschedule"></td>
                                <td style="text-align:left;">{{ row.court_name }}</td>
                                <td style="text-align:center;">{{ row.schedule_time }}</td>                                
                                <td style="text-align:right;">{{ row.quantity }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>                      
                      </div>
                    </div> 
                  </div>
                </div>
              </div>  
              <input type="hidden" class="form-control" v-model="formData.id">                                                                   
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>                
                <button v-if="viewMode != MODE_VIEW" @click="onCancel()" class="btn btn-warning pull-right">Cancel</button>    
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right" style="margin-right:15px;">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>                            
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import moment from 'moment'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_CREATE = 'create'
const MODE_UPDATE = 'update'
const TAB_OVERVIEW = 'tabOverview'
const TAB_DETAIL = 'tabDetail'

export default {
  name: 'CourtForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_CALENDAR: config.dateFormatSql,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_DETAIL: TAB_DETAIL,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        company_id: 0,
        company_name: '',
        project_id: 0,
        project_name: '',
        reserve_date: '',
        status: '',
        membership_id: 0,
        resechdul_status: false
      },
      inquiryParamDetail: {
        WhereClause: ''
      },
      startSequenceDetail: 0,
      showValidFrom: true,
      listProject: null,
      listDetail: null,
      listReschdule: null,
      listStatus: [
        { id: 'Draft', name: 'Draft' },
        { id: 'Confirmed', name: 'Confirmed' },
        { id: 'Canceled', name: 'Cancelled' }
      ],
      tabActive: '',
      originalcallback: '',
      prevRoute: null,
      date_reschedule: '',
      showRescheduleDate: true,
      showReschedule: false,
      loadingReschedule: false,
      loadingSaveReschedule: false,
      selectedReschedule: []
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.getProject()

    if (this.viewMode !== MODE_CREATE) {
      this.getDetail()
    }
  },
  mounted() {
  },
  methods: {
    updateDateField() {
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
    },
    getProject() {
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=&PageSize=9999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          this.listProject = response.data.entity
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getDetail() {
      api
        .request('Reservation', 'get', '/api/Reservation/' + this.formData.id, null)
        .then(response => {
          this.formData = response.data.entity

          this.updateDateField()
        })
        .catch(error => {
          let message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.email = ''
      this.formData.first_name = ''
      this.formData.last_name = ''
      this.formData.phone = ''
      this.formData.company_id = 0
      this.formData.company_name = ''
      this.formData.project_id = 0
      this.formData.project_name = ''
      this.formData.reserve_date = ''
      this.formData.status = ''
      this.formData.membership_id = 0
      this.formData.resechdul_status = false

      this.updateDateField()
    },
    onEdit(formData) {
      this.viewMode = MODE_UPDATE

      this.formData.id = formData.id
      this.formData.name = formData.name
      this.formData.email = formData.email
      this.formData.first_name = formData.first_name
      this.formData.last_name = formData.last_name
      this.formData.phone = formData.phone
      this.formData.company_id = formData.company_id
      this.formData.company_name = formData.company_name
      this.formData.project_id = formData.project_id
      this.formData.project_name = formData.project_name
      this.formData.reserve_date = formData.reserve_date
      this.formData.status = formData.status
      this.formData.membership_id = formData.membership_id

      this.updateDateField()
    },
    onCancel() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else {
        this.getDetail()
      }
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    },
    onSave() {
      let reqData = {
        id: this.formData.id,
        name: this.formData.name,
        email: this.formData.email,
        first_name: this.formData.first_name,
        last_name: this.formData.last_name,
        phone: this.formData.phone,
        company_id: this.formData.company_id,
        company_name: this.formData.company_name,
        project_id: this.formData.project_id,
        project_name: this.formData.project_name,
        reserve_date: $('#reserve_date').val(),
        status: this.formData.status,
        membership_id: this.formData.membership_id
      }

      let status = 'success'
      let message = ''
      let method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'post'
          break
        case MODE_UPDATE:
          method = 'put'
          break
      }

      api
        .request('Reservation', method, '/api/Reservation', reqData)
        .then(response => {
          let resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
          this.formData.id = resData.entity.id
        })
        .then(response => {
          this.getDetail()
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })

      this.viewMode = MODE_VIEW
    },
    onClickTabDetail() {
      this.inquiryDetail()
    },
    inquiryDetail() {
      api
        .request('Reservation', 'get', '/api/Reservation/' + this.formData.id + '/Detail?WhereClause=&PageSize=9999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          this.listDetail = response.data.entity
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateReschedule(pDate) {
      let newDate = moment(pDate, this.DATE_FORMAT)
      newDate.add(1, 'days')
      let newFormattedDate = newDate.format(this.DATE_FORMAT)
      this.onGenerateReschedule(newFormattedDate)
    },
    onGenerateReschedule(pDate) {
      this.showRescheduleDate = false
      this.showReschedule = false
      this.loadingReschedule = true
      this.date_reschedule = pDate
      let reserveDateString = moment(pDate, this.DATE_FORMAT).format(this.DATE_FORMAT_CALENDAR)
      api
        .request('Reservation', 'get', `/api/Reservation/AvaibleReservation?ProjectId=${this.formData.project_id}&CourtId=${this.listDetail[0].court_id}&Date=${reserveDateString}`, null, null)
        .then(response => {
          this.listReschdule = response.data.entity
          this.showReschedule = true
          this.showRescheduleDate = true
          this.loadingReschedule = false
        })
        .catch(error => {
          this.showReschedule = false
          this.showRescheduleDate = true
          this.loadingReschedule = false
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onChangeRescheduleDate(newDate) {
      this.onGenerateReschedule(newDate)
    },
    async onSubmitReschedule() {
      this.loadingSaveReschedule = true
      if (this.selectedReschedule.length === 0) {
        SweetAlert.fire('Error', 'Pastikan mimilih jadwal yang tersedia', 'error')
        this.loadingSaveReschedule = false
        return
      } else if (this.selectedReschedule.length > this.listDetail.length) {
        SweetAlert.fire('Error', 'Pastikan Jumlah jadwal perubahan nya tidak melebih yang diboking', 'error')
        this.loadingSaveReschedule = false
        return
      }

      let courtScheduleId = this.listReschdule.filter(row => this.selectedReschedule.includes(row.id)).map(rowDetail => rowDetail.court_schedule_id)
      let reqData = {
        reserve_id: this.formData.id,
        reserve_date: moment(this.date_reschedule, this.DATE_FORMAT).format(this.DATE_FORMAT_CALENDAR),
        court_schedule_id: courtScheduleId
      }
      let status = 'success'
      let message = ''
      this.showValidFrom = false
      await api
        .request('Reservation', 'post', `/api/Reservation/${this.formData.id}/Detail/Multi`, reqData)
        .then(response => {
          let resData = response.data
          if (resData.returnStatus) {
            this.formData.reserve_date = this.date_reschedule
            this.formData.id = response.data.entity.reserve_id
            this.getDetail()
            this.inquiryDetail()
          }
          this.loadingSaveReschedule = false
          this.showReschedule = false
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
          this.$nextTick(() => {
            this.showValidFrom = true
          })
        })
        .catch(error => {
          console.log('error catcht')
          this.loadingSaveReschedule = false
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
hr.line {
  margin-top: 30px;
	border-top: 1px solid #c2c2c2;
	border-bottom: 1px solid #fff;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ReservationForm.vue?60613814